import Navigation from './components/Navigation';
import Hero from './components/Hero';
import ProblemSolution from './components/ProblemSolution';
import Contributors from './components/Contributors';
import GetInvolved from './components/GetInvolved';
import Services from './components/Services';

import Events from './components/Events';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-matou-bg">
      <Navigation />
      <Hero />
      <ProblemSolution />
      <Contributors />
      <GetInvolved />
      <Services />
      <Events />
      <Contact />
      <Footer />
    </div>
  );
}
